//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapMutations } from 'vuex'

export default {
  name: 'Blog',

  async asyncData({ $content, params }) {
    const posts = await $content('blog', params.slug)
      .only(['title', 'description', 'img', 'slug'])
      .sortBy('createdAt', 'asc')
      .fetch()
    
    return {
      posts,
    }
  },

  data: () => ({
    title: 'Blog - ArtForge Tezos NFT Launchpad',
    description: 'Blog Posts by ArtForge, The Tezos NFT Launchpad',
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        // Open Graph
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },
        // // Twitter Card
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.title,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
      ],
    }
  },
  created() {
    // this.$store.commit('SET_APP_BAR_COLOR', '#FFF')
    // this.$store.commit('SET_APP_TITLE_COLOR', '#000')
  },
}
